<template>
	<transition-height name="fade">
		<div v-if="promotedNewsItem" class="news-promo-alert" @click.stop.prevent="$router.push({name: 'news-item', params: { id: promotedNewsItem.id}})">
			<button :title="t.genericDismiss" class="close" @click.stop.prevent="dismiss">
				×
			</button>

			<div class="title">
				{{ getTranslation(promotedNewsItem.title) }}
			</div>
			<div class="intro" v-html="getTranslation(promotedNewsItem.intro)" />
		</div>
	</transition-height>
</template>

<script setup>
import { computed, inject, onBeforeUnmount, onMounted } from "vue"
import { getTranslation } from "../../includes/helpers"
import { useStore } from '@/js/stores/index';
import { useNewsStore } from "@/js/stores/news";

const axios = inject('axios')
const store = useStore()
const newsStore = useNewsStore()

let timeoutId = null;

// Computeds
const t = computed(() => store.translations)
const promotedNewsItem = computed(() => newsStore.promotedNewsItem)

// Lifecycle
onBeforeUnmount(() => {
	clearTimeout(timeoutId)
})

onMounted(() => {
	// Delay loading news information for 5 sec. It's not urgent
	timeoutId = setTimeout(loadUserPromotedNewsItem, 5000)
})

// Methods
async function loadUserPromotedNewsItem(){
	newsStore.promotedNewsItem = (await axios.get('/api/user-side/getPromotedNewsItem')).data || null
}

function dismiss(event){
	event.target.blur() // Need to blur button, as it makes transition uglier
	
	// Save dismissing news id before resetting it 
	const newsItemId = promotedNewsItem.value?.id

	// Let's try to be optimistic and remove item immediately, not waiting for promise
	newsStore.promotedNewsItem = null

	// Send dismiss action to the backend
	axios.get('/api/user-side/dismissUserPromotedNewsItem/' + newsItemId)

	// Try again for another news item 
	setTimeout(loadUserPromotedNewsItem, 5000)	
}
</script>
